module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/45363a20eb3d7b2a57429ebc71777d1d.png";